var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      staticClass: "yxtbiz-labelling",
      attrs: {
        title: _vm.title,
        visible: _vm.drawerVisible,
        "destroy-on-close": "",
        size: "960px",
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _vm.drawerVisible
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "labelling",
            },
            [
              _c(
                "div",
                { staticClass: "mr32 flex-1 overflow-x-hidden flex flex-col" },
                [
                  _c("div", { staticClass: "labelling__filter" }, [
                    _c(
                      "div",
                      { staticClass: "labelling__filter-search" },
                      [
                        _c(
                          "yxt-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "pc_biz_labelling_classify" /*标签分类*/
                              ),
                              size: "small",
                            },
                            model: {
                              value: _vm.tagType,
                              callback: function ($$v) {
                                _vm.tagType = $$v
                              },
                              expression: "tagType",
                            },
                          },
                          [
                            _c("yxt-option", {
                              attrs: {
                                label: _vm.$t("pc_biz_labelling_lbl_normal"),
                                value: 0,
                              },
                            }),
                            _c("yxt-option", {
                              attrs: {
                                label: _vm.$t("pc_biz_labelling_lbl_layered"),
                                value: 1,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "labelling__filter-select" },
                      [
                        _c(
                          "yxt-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("pc_biz_labelling_classify"),
                              size: "small",
                            },
                            on: { change: _vm.catalogChange },
                            model: {
                              value: _vm.currentCatalog,
                              callback: function ($$v) {
                                _vm.currentCatalog = $$v
                              },
                              expression: "currentCatalog",
                            },
                          },
                          _vm._l(_vm.catalog, function (item) {
                            return _c("yxt-option", {
                              key: item.id,
                              attrs: {
                                label: item.catalogName,
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ml12" },
                      [
                        _c("yxt-input", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            placeholder: _vm.$t("pc_biz_labelling_input_tip"),
                            clearable: "",
                            searchable: "",
                            size: "small",
                          },
                          on: {
                            search: _vm.getLabellingTagList,
                            clear: _vm.getLabellingTagList,
                          },
                          model: {
                            value: _vm.params.keyWord,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "keyWord", $$v)
                            },
                            expression: "params.keyWord",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
                    _c("div", { staticClass: "labelling__list" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tagType === 0,
                              expression: "tagType===0",
                            },
                          ],
                          staticClass: "labelling__list__normal",
                        },
                        [
                          _vm.normalTags.length === 0 && !_vm.loading
                            ? _c("yxt-empty")
                            : _vm._l(_vm.normalTags, function (tag) {
                                return _c(
                                  "selectable-tag",
                                  {
                                    key: tag.tagId,
                                    attrs: { selected: tag.selected },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handelTagSelected(tag)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "yxt-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          "open-filter": "",
                                          content: tag.tagName,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "ellipsis" },
                                          [_vm._v(_vm._s(tag.tagName))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tagType === 1,
                              expression: "tagType===1",
                            },
                          ],
                          staticClass: "labelling__list__layered",
                        },
                        [
                          _vm.layeredTags.length === 0 && !_vm.loading
                            ? _c("yxt-empty")
                            : _vm._l(_vm.layeredTags, function (tag) {
                                return _c(
                                  "div",
                                  {
                                    key: tag.tagId,
                                    staticClass: "layered__group",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "layered__group-name" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(tag.tagName)
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "（" +
                                              _vm._s(
                                                tag.valueChooseModel
                                                  ? _vm.$t(
                                                      "pc_biz_labelling_input_multi"
                                                    )
                                                  : _vm.$t(
                                                      "pc_biz_labelling_input_single"
                                                    )
                                              ) +
                                              "）"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "layered__group-tags" },
                                      _vm._l(
                                        tag.tagValueBeanList,
                                        function (tagOption) {
                                          return _c(
                                            "selectable-tag",
                                            {
                                              key: tagOption.tagValueId,
                                              attrs: {
                                                selected: tagOption.selected,
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handelLayeredTagSelected(
                                                    tagOption,
                                                    tag
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "yxt-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    "open-filter": "",
                                                    content:
                                                      tagOption.tagValueName,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "ellipsis" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          tagOption.tagValueName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                )
                              }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex-shrink-0 border-left labelling__selected",
                },
                [
                  _c(
                    "div",
                    { staticClass: "labelling__selected-title" },
                    [
                      _c("div", { staticClass: "font-medium" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_labelling_selected")) +
                            _vm._s(_vm.totalCount) +
                            "\n        "
                        ),
                      ]),
                      _c(
                        "yxt-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.clearAll },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("pc_biz_labelling_clearall")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mt16 overflow-hidden" },
                    [
                      _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
                        _vm.layeredTagsComputed &&
                        _vm.layeredTagsComputed.length
                          ? _c("div", [
                              _c("div", { staticClass: "color-gray-9 mb8" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pc_biz_labelling_lbl_layered")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "clearfix pb16" },
                                [
                                  _vm._l(
                                    _vm.layeredTagsComputed,
                                    function (layeredTag) {
                                      return [
                                        _vm._l(
                                          layeredTag.tagValueList,
                                          function (tagValue) {
                                            return [
                                              _c(
                                                "yxt-tooltip",
                                                {
                                                  key:
                                                    layeredTag.tagId +
                                                    tagValue.tagValueId,
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      layeredTag.tagName +
                                                      "：" +
                                                      tagValue.tagValueName,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "yxt-tag",
                                                    {
                                                      staticClass:
                                                        "mr8 overflow-hidden mb8 standard-size-12 labelling__selected-tag clearfix",
                                                      attrs: {
                                                        type: "info",
                                                        size: "mini",
                                                        closable: "",
                                                      },
                                                      on: {
                                                        close: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleCloseTag(
                                                            layeredTag,
                                                            tagValue,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ellipsis",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              layeredTag.tagName
                                                            ) +
                                                              "：" +
                                                              _vm._s(
                                                                tagValue.tagValueName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                        _vm.normalSelectedTags && _vm.normalSelectedTags.length
                          ? _c("div", [
                              _c("div", { staticClass: "color-gray-9 mb8" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pc_biz_labelling_lbl_normal")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "clearfix pb16" },
                                [
                                  _vm._l(
                                    _vm.normalSelectedTags,
                                    function (normalTag) {
                                      return [
                                        _c(
                                          "yxt-tooltip",
                                          {
                                            key: normalTag.tagId,
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: normalTag.tagName,
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "yxt-tag",
                                              {
                                                staticClass:
                                                  "mr8 overflow-hidden mb8 standard-size-12 labelling__selected-tag clearfix",
                                                attrs: {
                                                  type: "info",
                                                  size: "mini",
                                                  closable: "",
                                                },
                                                on: {
                                                  close: function ($event) {
                                                    return _vm.handleCloseTag(
                                                      normalTag,
                                                      null,
                                                      0
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "ellipsis" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(normalTag.tagName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_labelling_cancel" /*取消*/)) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            {
              attrs: { loading: _vm.submitLoading, type: "primary" },
              on: { click: _vm.submit },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_labelling_confirm" /*确定*/)) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }